import {localizeImage} from '../../i18n/images';
import {useTranslation} from '../../i18n/translation';
import React, {useRef, useMemo, useState, useEffect, useCallback} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {FilterBar} from "../utils/filterBar"

import "../../css/menuHeader/menuCard.css";
import "../../css/menuHeader/menuCardManyObjects.css";
import "../../css/menuHeader/menuCardLowObjects.css";

import Navigation from "../utils/Navigation";

import siteStructure from "../siteStructure.json"
import {findElementByLink, findNodePath, getAllProductsCached} from "../utils/siteStructure";
import SeoHelmet from "../utils/seo";
import {useTheme} from "../header/Header";
import '../../css/ariaLabel.css';


export const FILTER_TYPES = {
    CHECKBOX: 'checkbox',
    DIGITAL: 'digital'
};

const getImage = (path) => {
    if (!path) return "";
    const clean = String(path).replace(/^\.?\//, "");
    return `/images/${clean}`;
}

const getItemPath = (item, currentPath, english) => {
    if (item.useAbsolutePath) {
        return `${english ? "/en" : ""}${item.nav}`;
    }
    return `${english ? '/en' : ''}${currentPath}/${item.nav}`.replace(/\/+/g, '/');
};

function MenuCard({items, path, tagsData, theme}) {
    const {english, t} = useTranslation();
    return (
        <div key={path} className={"overlay"}>
            <div className={`complexBack ${theme}`}> </div>
            <div className="menu-container">
                {items.map((item, index) => (
                    <div key={index} className="menu-item-wrapper">
                        <Link to={getItemPath(item, path, english)} className="menu-item">
                            <div className={`image-container ${theme}`}>
                                <img src={getImage(localizeImage(item.image, english))} alt={t(item.title)} className="menu-image"/>
                            </div>
                            <div className={`menuText ${theme}`}>
                                {t(item.title)}
                                {item.addTitle ? <p>{t(item.addTitle)}</p> : null}
                            </div>
                        </Link>
                        {item.tags && item.tags.length > 0 && (
                            <div className="tags-container">
                                {item.tags.map((tag, tagIndex) => (
                                    <Tag key={tagIndex} item={tag} tagsData={tagsData}/>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

function MenuCardManyObjects({items, path, tagsData, theme}) {
    const {english, t} = useTranslation();
    return (
        <div key={path} className={"overlay"}>
            <div className={`complexBack ${theme}`}> </div>
            <div className="menuManyObj-container">
                {items.map((item, index) => (
                    <div key={index} className="menuManyObj-item-wrapper">
                        <Link to={getItemPath(item, path, english)} className="menuManyObj-item">
                            <div className={`menuManyObj-image-container ${theme}`}>
                                <img src={getImage(localizeImage(item.image, english))} alt={t(item.title)} className="menuManyObj-image"/>
                            </div>
                            <div className={`menuManyObjText ${theme}`}>
                                {t(item.title)}
                                {item.addTitle ? <p>{t(item.addTitle)}</p> : null}
                            </div>
                        </Link>
                        {item.tags && item.tags.length > 0 && (
                            <div className="tags-container">
                                {item.tags.map((tag, tagIndex) => (
                                    <Tag key={tagIndex} item={tag} tagsData={tagsData}/>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

function MenuCardLowObjects({items, path, tagsData, theme}) {
    const {english, t} = useTranslation();
    return (
        <div key={path} className={`overlay`}>
            <div className={`complexBack ${theme}`}> </div>
            <div className="menuLowObj-container">
                {items.map((item, index) => (
                    <div key={index} className="menuLowObj-item-wrapper">
                        <Link to={getItemPath(item, path, english)} className="menuLowObj-item">
                            <div className={`menuLowObj-image-container ${theme}`}>
                                <img src={getImage(localizeImage(item.image, english))} alt={t(item.title)} className="menuLowObj-image"/>
                            </div>
                            <div className={`menuLowObjText ${theme}`}>
                                {t(item.title)}
                                {item.addTitle ? <p>{t(item.addTitle)}</p> : null}
                            </div>
                        </Link>
                        {item.tags && item.tags.length > 0 && (
                            <div className="tags-container">
                                {item.tags.map((tag, tagIndex) => (
                                    <Tag key={tagIndex} item={tag} tagsData={tagsData}/>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

function MenuCardWithBar({ items, path, tagsData, theme }) {
    const {english, t} = useTranslation();

    return (
        <div key={`${path}-${items.map(item => item.url).join('-')}`} className={`overlay`}>
            <div className={`complexBack ${theme}`}> </div>
            <div className="menu-card-with-bar">
                <div className="products-container">
                    {items.length === 0? <h2 className={"notFound"}>{t("По вашим параметрам ничего не нашлось. Попробуйте сбросить фильтры.")}</h2> : ""}
                    <div
                        className="products-flex"
                        data-item-count={items.length}
                    >
                        {items.map((item, index) => (
                            <div key={index} className={`product-bar-card ${theme} ${item.type === "menu"? "product-category" : ""}`}>
                                {/* Теги */}
                                {item.tags && item.tags.length > 0 && (
                                    <div className="tags-container">
                                        {item.tags.map((tag, tagIndex) => (
                                            <Tag key={tagIndex} item={tag} tagsData={tagsData}/>
                                        ))}
                                    </div>
                                )}

                                <Link to={getItemPath(item, path, english)} className={`product-bar-link ${theme}`}>
                                    <div className="product-bar-image-container">
                                        <img
                                            src={getImage(localizeImage(item.image, english))}
                                            alt={t(item.title)}
                                            className="product-bar-image"
                                        />
                                    </div>
                                    <div className="product-bar-info">
                                        <h3
                                            className="product-bar-title"
                                            data-full-text={t(item.title)}
                                        >
                                            {t(item.title)}
                                        </h3>
                                        {item.addTitle && (
                                            <p className="product-bar-subtitle">{t(item.addTitle)}</p>
                                        )}
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

function Tag({item, tagsData}) {
    const {english, t} = useTranslation();
    return (
        <Link
            to={`${english ? '/en' : ''}/${tagsData[item.key]?.url || '#'}`}
            className="product-tag"
            onClick={(e) => e.stopPropagation()}
            data-cooltipz-dir="bottom"
            aria-label={t(tagsData[item.key]?.title || "")}
        >
            <span className="tag-content short-text">
                {t(item.name)}
            </span>
        </Link>
    );
}

const usePropertyFilters = () => {
    const [propertyFilters, setPropertyFilters] = useState({});

    const updatePropertyFilter = useCallback((propertyName, value, isChecked) => {
        setPropertyFilters(prev => {
            const newFilters = { ...prev };

            // Если value - объект (для digital фильтров), просто заменяем значение
            if (typeof value === 'object' && !Array.isArray(value)) {
                if (Object.keys(value).length === 0) {
                    // Если объект пустой - удаляем фильтр
                    delete newFilters[propertyName];
                } else {
                    newFilters[propertyName] = value;
                }
            }
            // Старая логика для чекбоксов
            else {
                if (!newFilters[propertyName]) {
                    newFilters[propertyName] = [];
                }

                if (isChecked) {
                    newFilters[propertyName] = [...newFilters[propertyName], value];
                } else {
                    newFilters[propertyName] = newFilters[propertyName].filter(v => v !== value);
                }

                if (newFilters[propertyName].length === 0) {
                    delete newFilters[propertyName];
                }
            }

            return newFilters;
        });
    }, []);

    const resetPropertyFilters = useCallback(() => {
        setPropertyFilters({});
    }, []);

    return {
        propertyFilters,
        setPropertyFilters,
        updatePropertyFilter,
        resetPropertyFilters
    };
};

// Вспомогательные функции
const buildContextCategories = (baseElement, basePath, currentPath) => {
    if (!baseElement) return [];

    const categories = [{
        path: `/${basePath}`,
        title: baseElement.title,
        isCurrent: currentPath === `/${basePath}`,
        level: 0,
        hasChildren: false
    }];

    if (!baseElement.links) return categories;

    const level1Categories = [];
    Object.keys(baseElement.links).forEach(key => {
        const child = baseElement.links[key];
        if (child.type !== "menu") return;

        const childPath = `${basePath}/${key}`;
        const isCurrent = currentPath === `/${childPath}`;
        const childElement = findElementByLink(siteStructure, childPath, true);
        const hasChildren = childElement?.links &&
            Object.keys(childElement.links).some(subKey =>
                childElement.links[subKey].type === "menu"
            );

        level1Categories.push({
            path: `/${childPath}`,
            title: child.title,
            isCurrent,
            level: 1,
            hasChildren,
            element: childElement
        });
    });

    level1Categories.forEach(category => {
        const normalizedCurrentPath = currentPath.replace(/^\/|\/$/g, '');
        const isInsideCategory = normalizedCurrentPath === category.path.replace(/^\//, '') ||
            normalizedCurrentPath.startsWith(category.path.replace(/^\//, '') + '/');

        categories.push({
            ...category,
            showChildren: isInsideCategory && category.hasChildren
        });

        if (isInsideCategory && category.hasChildren && category.element?.links) {
            Object.keys(category.element.links).forEach(subKey => {
                const subChild = category.element.links[subKey];
                if (subChild.type !== "menu") return;

                const subChildPath = `${category.path.replace(/^\//, '')}/${subKey}`;
                categories.push({
                    path: `/${subChildPath}`,
                    title: subChild.title,
                    isCurrent: currentPath === `/${subChildPath}`,
                    level: 2,
                    hasChildren: false,
                    showChildren: false
                });
            });
        }
    });

    return categories;
};

const collectTagsFromProducts = (products) => {
    const tagsSet = new Set();
    const tagsList = [];

    products.forEach(product => {
        const productTags = product.tags || (product.tag ? [product.tag] : []);
        productTags.forEach(tag => {
            const tagKey = JSON.stringify(tag);
            if (!tagsSet.has(tagKey)) {
                tagsSet.add(tagKey);
                tagsList.push(tag);
            }
        });
    });

    return tagsList;
};

const getProductsForContext = (allSiteProducts, currentPath, includeNested) => {
    if (includeNested) {
        return allSiteProducts.filter(product =>
            product.url.startsWith(currentPath)
        );
    }

    return allSiteProducts.filter(product => {
        const productPathParts = product.url.split('/');
        const currentPathParts = currentPath.split('/');
        return product.url.startsWith(currentPath) &&
            productPathParts.length === currentPathParts.length + 1;
    });
};

// Функции для работы с цифровыми фильтрами
const extractNumberFromString = (str) => {
    if (!str) return null;

    // Ищем числа в строке, включая десятичные дроби
    const matches = str.match(/-?\d+(\.\d+)?/g);
    if (!matches || matches.length === 0) return null;

    // Берем первое найденное число
    const number = parseFloat(matches[0]);
    return isNaN(number) ? null : number;
};

const collectDigitalValues = (products, propertyName) => {
    const numbers = [];

    products.forEach(product => {
        if (product.property && product.property.about) {
            const prop = product.property.about.find(item => item[0] === propertyName);
            if (prop && prop[1]) {
                const number = extractNumberFromString(prop[1]);
                if (number !== null) {
                    numbers.push(number);
                }
            }
        }
    });

    if (numbers.length === 0) return null;

    return {
        min: Math.min(...numbers),
        max: Math.max(...numbers),
        values: [...new Set(numbers)].sort((a, b) => a - b)
    };
};

// Основной компонент
export function MenuCardWrapper({ items }) {
    const tagsData = useRef({});
    const routerLocation = useLocation();
    const {english} = useTranslation();
    const location = {...routerLocation, pathname: routerLocation.pathname.replace(/^\/en(?=\/|$)/, "") || "/"};
    const navigate = useNavigate();
    const [selectedTags, setSelectedTags] = useState([]);
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
    const {theme} = useTheme()

    // Функции для управления мобильным фильтром
    const handleMobileFilterToggle = () => {
        setIsMobileFilterOpen(!isMobileFilterOpen);
    };

    const handleMobileFilterClose = () => {
        setIsMobileFilterOpen(false);
    };

    // Используем кастомный хук для фильтров свойств
    const {
        propertyFilters,
        setPropertyFilters,
        updatePropertyFilter,
        resetPropertyFilters
    } = usePropertyFilters();

    // Получаем текущий элемент страницы
    const currentElement = useMemo(() => {
        return findElementByLink(siteStructure, location.pathname.replace(/^\/|\/$/g, ''));
    }, [location.pathname]);

    // Получаем все продукты сайта
    const allSiteProducts = useMemo(() => {
        return getAllProductsCached(siteStructure);
    }, []);

    // Проверяем, есть ли у текущей страницы enableGlobalFilter
    const currentPageHasGlobalFilter = useMemo(() => {
        return !!(currentElement && currentElement.enableGlobalFilter);
    }, [currentElement]);

    // Функция для поиска любого родителя с enableGlobalFilter в иерархии
    const findParentWithGlobalFilter = useCallback((path) => {
        const pathParts = path.replace(/^\/|\/$/g, '').split('/');

        for (let i = pathParts.length - 1; i >= 0; i--) {
            const parentPath = pathParts.slice(0, i).join('/');
            if (!parentPath) continue;

            const parentElement = findElementByLink(siteStructure, parentPath, true);
            if (parentElement && parentElement.enableGlobalFilter) {
                return {
                    parentHasGlobalFilter: true,
                    parentPath: parentPath,
                    parentElement: parentElement
                };
            }
        }

        return { parentHasGlobalFilter: false, parentPath: '', parentElement: null };
    }, []);

    // Ищем любого родителя с enableGlobalFilter в иерархии
    const { parentHasGlobalFilter, parentPath, parentElement } = useMemo(() => {
        return findParentWithGlobalFilter(location.pathname);
    }, [location.pathname, findParentWithGlobalFilter]);

    // Определяем, нужно ли показывать панель фильтров
    const showFilterPanel = useMemo(() => {
        return currentPageHasGlobalFilter || parentHasGlobalFilter;
    }, [currentPageHasGlobalFilter, parentHasGlobalFilter]);

    // Получаем свойства для фильтрации из текущего элемента или родителя
    const availableProperties = useMemo(() => {
        const properties = new Map();

        const addProperty = (prop) => {
            // Поддержка старого формата (просто строки)
            if (typeof prop === 'string') {
                if (!properties.has(prop)) {
                    properties.set(prop, {
                        name: prop,
                        type: FILTER_TYPES.CHECKBOX
                    });
                }
            }
            // Новый формат (объекты)
            else if (prop && prop.name) {
                if (!properties.has(prop.name)) {
                    properties.set(prop.name, {
                        ...prop, // Копируем все поля из prop
                        type: prop.type || FILTER_TYPES.CHECKBOX // Если type не указан, по умолчанию CHECKBOX
                    });
                }
            }
        };

        // Функция для рекурсивного сбора свойств фильтрации из цепочки родителей
        const collectPropertiesFromHierarchy = (element, path) => {
            if (!element || !path) return;

            // Добавляем свойства текущего элемента
            if (element.filter) {
                element.filter.forEach(prop => addProperty(prop));
            }

            // Если это не корневой элемент, ищем родителя и продолжаем рекурсию
            const pathParts = path.split('/');
            if (pathParts.length <= 1) return;

            // Поднимаемся на уровень выше
            const parentPath = pathParts.slice(0, -1).join('/');
            if (!parentPath) return;

            const parentElement = findElementByLink(siteStructure, parentPath, true);
            if (parentElement) {
                collectPropertiesFromHierarchy(parentElement, parentPath);
            }
        };

        const currentPath = location.pathname.replace(/^\/|\/$/g, '');

        // Собираем свойства от текущего элемента и всех его родителей
        if (currentElement) {
            collectPropertiesFromHierarchy(currentElement, currentPath);
        }

        // Также добавляем свойства от родителя с enableGlobalFilter (если он есть)
        if (parentHasGlobalFilter && parentElement && parentElement.filter) {
            parentElement.filter.forEach(prop => addProperty(prop));
        }

        return Array.from(properties.values());
    }, [currentElement, parentElement, parentHasGlobalFilter, location.pathname]);

    // Получаем все дочерние элементы для текущего контекста с учетом вложенности
    const contextCategories = useMemo(() => {
        const currentPath = location.pathname.replace(/^\/|\/$/g, '');

        if (parentHasGlobalFilter && parentElement) {
            return buildContextCategories(parentElement, parentPath, location.pathname);
        }

        if (currentPageHasGlobalFilter && currentElement) {
            return buildContextCategories(currentElement, currentPath, location.pathname);
        }

        return [];
    }, [currentPageHasGlobalFilter, parentHasGlobalFilter, currentElement, parentElement, parentPath, location.pathname]);

    // Получаем продукты для текущей страницы
    const currentPageProducts = useMemo(() => {
        const currentPath = location.pathname.replace(/^\/|\/$/g, '');
        const includeNested = (currentPageHasGlobalFilter || parentHasGlobalFilter) &&
            currentElement?.links;

        if (currentPageHasGlobalFilter || parentHasGlobalFilter) {
            return getProductsForContext(allSiteProducts, currentPath, includeNested);
        }

        return allSiteProducts.filter(product => product.url === currentPath);
    }, [currentPageHasGlobalFilter, parentHasGlobalFilter, currentElement, allSiteProducts, location.pathname]);

    // Преобразуем items, чтобы у всех был массив tags (для единообразия)
    const normalizedItems = useMemo(() => {
        return items.map(item => ({
            ...item,
            tags: item.tags || (item.tag ? [item.tag] : [])
        }));
    }, [items]);

    // Функция для проверки, есть ли в категории товары с выбранными тегами
    const hasProductsWithSelectedTags = useCallback((categoryPath) => {
        if (selectedTags.length === 0) return true;

        const categoryPathWithoutSlash = categoryPath.replace(/^\//, '');

        // Находим все товары, принадлежащие этой категории
        const categoryProducts = allSiteProducts.filter(product =>
            product.url.startsWith(categoryPathWithoutSlash)
        );

        // Проверяем, есть ли среди них товары с выбранными тегами
        return categoryProducts.some(product => {
            const productTags = product.tags || (product.tag ? [product.tag] : []);
            return productTags.some(tag => selectedTags.includes(tag.key));
        });
    }, [selectedTags, allSiteProducts]);

    // Динамически фильтруем категории на основе выбранных тегах
    const visibleContextCategories = useMemo(() => {
        if (!contextCategories.length) return [];

        const currentPath = location.pathname.replace(/^\/|\/$/g, '');
        const currentPathParts = currentPath.split('/');

        // Собираем пути всех родительских категорий текущей страницы
        const parentPaths = [];
        for (let i = 1; i <= currentPathParts.length; i++) {
            const parentPath = currentPathParts.slice(0, i).join('/');
            parentPaths.push(parentPath);
        }

        return contextCategories.filter(category => {
            const categoryPathWithoutSlash = category.path.replace(/^\//, '');

            // Всегда показываем:
            // 1. Текущую категорию
            // 2. Родительские категории текущей страницы
            // 3. Категории уровня 0 (основные разделы)
            if (category.isCurrent ||
                parentPaths.includes(categoryPathWithoutSlash) ||
                category.level === 0) {
                return true;
            }

            // Для остальных категорий проверяем наличие товаров с выбранными тегами
            return hasProductsWithSelectedTags(category.path);
        });
    }, [contextCategories, location.pathname, hasProductsWithSelectedTags]);

    // Собираем все уникальные теги из продуктов текущей страницы
    const allTags = useMemo(() => {
        const currentPath = location.pathname.replace(/^\/|\/$/g, '');
        let productsToCheck = [...currentPageProducts];

        // Добавляем продукты из поддерева если нужно
        if (parentHasGlobalFilter && currentElement?.links) {
            const subtreeProducts = allSiteProducts.filter(product =>
                product.url.startsWith(currentPath) && product.url !== currentPath
            );
            productsToCheck = [...productsToCheck, ...subtreeProducts];
        }

        return collectTagsFromProducts(productsToCheck);
    }, [currentPageProducts, parentHasGlobalFilter, currentElement, allSiteProducts, location.pathname]);

    // Обновляем visiblePropertyValues для поддержки разных типов
    const visiblePropertyValues = useMemo(() => {
        const values = {};

        if (availableProperties.length === 0) return values;

        // Определяем, нужно ли включать вложенные продукты
        const includeNestedProducts = currentElement && currentElement.links;

        // Получаем продукты для фильтрации
        let productsToCheck = includeNestedProducts ? currentPageProducts : normalizedItems;

        // Применяем фильтрацию по тегам
        let filteredByTags = productsToCheck;
        if (selectedTags.length > 0) {
            filteredByTags = productsToCheck.filter(product => {
                const productTags = product.tags || (product.tag ? [product.tag] : []);
                return productTags.some(tag => selectedTags.includes(tag.key));
            });
        }

        // Применяем фильтрацию по свойствам (кроме текущего свойства)
        availableProperties.forEach(propertyConfig => {
            const propName = propertyConfig.name;
            const propType = propertyConfig.type;

            if (propType === FILTER_TYPES.DIGITAL) {
                // Для цифровых фильтров собираем диапазон значений
                const digitalData = collectDigitalValues(filteredByTags, propName);
                if (digitalData) {
                    values[propName] = {
                        type: FILTER_TYPES.DIGITAL,
                        data: digitalData
                    };
                }
            } else {
                // Для чекбоксов собираем уникальные значения
                const propValues = new Set();

                // Фильтруем продукты по всем выбранным свойствам, кроме текущего
                let filteredProducts = filteredByTags;

                Object.entries(propertyFilters).forEach(([filterPropName, filterValue]) => {
                    if (filterPropName === propName) return;

                    const filterConfig = availableProperties.find(p => p.name === filterPropName);
                    console.log(filterConfig)
                    if (!filterConfig) return;

                    if (filterConfig.type === FILTER_TYPES.CHECKBOX) {
                        // Старая логика для чекбоксов
                        filteredProducts = filteredProducts.filter(product => {
                            if (product.property && product.property.about) {
                                const prop = product.property.about.find(item => item[0] === filterPropName);
                                return prop && filterValue.includes(prop[1]);
                            }
                            return false;
                        });
                    } else if (filterConfig.type === FILTER_TYPES.DIGITAL) {
                        // Новая логика для цифровых фильтров
                        filteredProducts = filteredProducts.filter(product => {
                            if (product.property && product.property.about) {
                                const prop = product.property.about.find(item => item[0] === filterPropName);
                                if (prop && prop[1]) {
                                    const number = extractNumberFromString(prop[1]);
                                    if (number === null) return false;

                                    if (filterValue.min !== undefined && number < filterValue.min) return false;
                                    return !(filterValue.max !== undefined && number > filterValue.max);

                                }
                            }
                            return false;
                        });
                    }
                });

                // Собираем значения текущего свойства из отфильтрованных продуктов
                filteredProducts.forEach(product => {
                    if (product.property && product.property.about) {
                        const prop = product.property.about.find(item => item[0] === propName);
                        if (prop && prop[1]) {
                            propValues.add(prop[1]);
                        }
                    }
                });

                values[propName] = {
                    type: FILTER_TYPES.CHECKBOX,
                    data: Array.from(propValues).sort()
                };
            }
        });

        return values;
    }, [availableProperties, selectedTags, propertyFilters, currentPageProducts, normalizedItems, currentElement]);

    // Фильтруем элементы для отображения
    const filteredItems = useMemo(() => {
        // Если нет выбранных тегов и фильтров свойств, показываем элементы текущей страницы по умолчанию
        if (selectedTags.length === 0 && Object.keys(propertyFilters).length === 0) {
            return normalizedItems;
        }

        // Определяем, нужно ли включать вложенные продукты
        const includeNestedProducts = currentElement && currentElement.links;

        // Получаем продукты для фильтрации
        let productsToFilter = includeNestedProducts ? currentPageProducts : normalizedItems;

        // Применяем фильтрацию по тегам
        let filteredByTags = productsToFilter;
        if (selectedTags.length > 0) {
            filteredByTags = productsToFilter.filter(product => {
                const productTags = product.tags || (product.tag ? [product.tag] : []);
                return productTags.some(tag => selectedTags.includes(tag.key));
            });
        }

        // Применяем фильтрацию по свойствам
        let filteredByProperties = filteredByTags;
        if (Object.keys(propertyFilters).length > 0) {
            filteredByProperties = filteredByTags.filter(product => {
                return Object.entries(propertyFilters).every(([propertyName, filterValue]) => {
                    if (!filterValue) return true;

                    const propertyConfig = availableProperties.find(p => p.name === propertyName);
                    if (!propertyConfig) return true;

                    if (propertyConfig.type === FILTER_TYPES.CHECKBOX) {
                        // Старая логика для чекбоксов
                        if (!filterValue || filterValue.length === 0) return true;

                        if (product.property && product.property.about) {
                            const itemProperty = product.property.about.find(prop => prop[0] === propertyName);
                            if (itemProperty && filterValue.includes(itemProperty[1])) {
                                return true;
                            }
                        }
                        return false;
                    } else if (propertyConfig.type === FILTER_TYPES.DIGITAL) {
                        // Новая логика для цифровых фильтров
                        if (product.property && product.property.about) {
                            const itemProperty = product.property.about.find(prop => prop[0] === propertyName);
                            if (itemProperty && itemProperty[1]) {
                                const number = extractNumberFromString(itemProperty[1]);
                                if (number === null) return false;

                                if (filterValue.min !== undefined && number < filterValue.min) return false;
                                return !(filterValue.max !== undefined && number > filterValue.max);

                            }
                        }
                        return false;
                    }

                    return true;
                });
            });
        }

        // Преобразуем продукты в элементы для отображения
        return filteredByProperties.map(product => ({
            ...product,
            useAbsolutePath: true,
            nav: `/${product.url}`
        }));
    }, [normalizedItems, selectedTags, propertyFilters, currentPageProducts, currentElement, availableProperties]);

    // Унифицированный useEffect для обновления фильтров свойств
    useEffect(() => {
        if (Object.keys(propertyFilters).length === 0) return;

        const updatedFilters = { ...propertyFilters };
        let needsUpdate = false;

        Object.keys(updatedFilters).forEach(propertyName => {
            const currentValues = updatedFilters[propertyName];
            const propertyConfig = availableProperties.find(p => p.name === propertyName);

            if (!propertyConfig) {
                delete updatedFilters[propertyName];
                needsUpdate = true;
                return;
            }

            if (propertyConfig.type === FILTER_TYPES.CHECKBOX) {
                // Для чекбоксов оставляем только те значения, которые есть в visiblePropertyValues
                const compatibleValues = currentValues.filter(value =>
                    visiblePropertyValues[propertyName]?.data?.includes(value)
                );

                if (compatibleValues.length !== currentValues.length) {
                    if (compatibleValues.length > 0) {
                        updatedFilters[propertyName] = compatibleValues;
                    } else {
                        delete updatedFilters[propertyName];
                    }
                    needsUpdate = true;
                }
            } else if (propertyConfig.type === FILTER_TYPES.DIGITAL) {
                // Для цифровых фильтров проверяем, что диапазон в пределах допустимого
                const digitalData = visiblePropertyValues[propertyName]?.data;
                if (!digitalData) {
                    delete updatedFilters[propertyName];
                    needsUpdate = true;
                    return;
                }

                const updatedFilter = { ...currentValues };
                let filterChanged = false;

                if (currentValues.min !== undefined && currentValues.min < digitalData.min) {
                    updatedFilter.min = digitalData.min;
                    filterChanged = true;
                }

                if (currentValues.max !== undefined && currentValues.max > digitalData.max) {
                    updatedFilter.max = digitalData.max;
                    filterChanged = true;
                }

                if (filterChanged) {
                    if (Object.keys(updatedFilter).length > 0) {
                        updatedFilters[propertyName] = updatedFilter;
                    } else {
                        delete updatedFilters[propertyName];
                    }
                    needsUpdate = true;
                }
            }
        });

        if (needsUpdate) {
            setPropertyFilters(updatedFilters);
        }
    }, [selectedTags, visiblePropertyValues, propertyFilters, availableProperties, setPropertyFilters]);

    // Сохраняем выбранные теги и сбрасываем свойства при переходе между страницами
    useEffect(() => {
        const isLeavingGroup = () => {
            if (!parentHasGlobalFilter && !currentPageHasGlobalFilter) return true;

            const pathParts = location.pathname.replace(/^\/|\/$/g, '').split('/');
            if (pathParts.length === 0) return true;

            if (parentHasGlobalFilter) {
                return !location.pathname.startsWith(`/${parentPath}`);
            }

            if (currentPageHasGlobalFilter) {
                const currentPath = location.pathname.replace(/^\/|\/$/g, '');
                return !location.pathname.startsWith(`/${currentPath}`);
            }

            return true;
        };

        if (isLeavingGroup()) {
            setSelectedTags([]);
            setPropertyFilters({}); // Сбрасываем фильтры свойств
        }
    }, [location.pathname, parentPath, parentHasGlobalFilter, currentPageHasGlobalFilter, setSelectedTags, setPropertyFilters]);

    // Дополнительно: сбрасываем фильтры свойств при изменении доступных свойств
    useEffect(() => {
        // Если изменились доступные свойства (например, перешли в другую категорию),
        // сбрасываем фильтры свойств
        setPropertyFilters({});
    }, [availableProperties, location.pathname, setPropertyFilters]);

    // Заполняем tagsData
    useMemo(() => {
        allTags.forEach(tag => {
            if (!tagsData.current[tag.key]) {
                tagsData.current[tag.key] = findNodePath(siteStructure, tag.key);
            }
        });
    }, [allTags]);

    // Функция для переключения тега
    const toggleTagFilter = (tagKey) => {
        setSelectedTags(prev => {
            if (prev.includes(tagKey)) {
                return prev.filter(key => key !== tagKey);
            } else {
                return [...prev, tagKey];
            }
        });
    };

    // Функция для навигации по категориям
    const handleCategoryNavigation = (path) => {
        navigate(`${english ? "/en" : ""}${path}`);
    };

    // Выбираем компонент для отображения
    let Component;
    if (filteredItems.length <= 3) {
        Component = MenuCardLowObjects;
    } else if (filteredItems.length <= 6) {
        Component = MenuCard;
    } else {
        Component = MenuCardManyObjects;
    }

    return (
        <div className={`menu-card-wrapper`}>
            {showFilterPanel ? (
                <div className="page-with-filters">
                    <FilterBar
                        showFilterPanel={showFilterPanel}
                        visibleContextCategories={visibleContextCategories}
                        handleCategoryNavigation={handleCategoryNavigation}
                        allTags={allTags}
                        selectedTags={selectedTags}
                        toggleTagFilter={toggleTagFilter}
                        setSelectedTags={setSelectedTags}
                        availableProperties={availableProperties}
                        visiblePropertyValues={visiblePropertyValues}
                        propertyFilters={propertyFilters}
                        updatePropertyFilter={updatePropertyFilter}
                        resetPropertyFilters={resetPropertyFilters}
                        isMobileFilterOpen={isMobileFilterOpen}
                        onMobileFilterToggle={handleMobileFilterToggle}
                        onMobileFilterClose={handleMobileFilterClose}
                    />
                    <MenuCardWithBar items={filteredItems} path={location.pathname} tagsData={tagsData.current} theme={theme}/>
                </div>
            ) : (
                <Component items={filteredItems} path={location.pathname} tagsData={tagsData.current} theme={theme} />
            )}
        </div>
    );
}

export function MenuCardPage({path}) {
    const {t} = useTranslation();

    const data = findElementByLink(siteStructure, path)
    const dataLinks = data.links ? data.links : {}

    const seo = data.seo ? data.seo : {title: "", description: "", keywords: "", changefreq: 'yearly', priority: 0.4}

    let items = []

    Object.keys(dataLinks).forEach(key => {
        items.push({
            nav: key,
            ...dataLinks[key],
            title: t(dataLinks[key].title)
        })
    })

    return (
        <div>
            <SeoHelmet
                title={t(seo.title)}
                description={t(seo.description)}
            />

            <Navigation/>
            <MenuCardWrapper items={items}/>
        </div>
    )
}
